import { Button, Row, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { convertBase64ToFile, downloadPaymentGetwayAttachments, getPaymentgetwayRequest } from "../../api/api";
import { useAppSelector, useAppDispatch } from "../../redux/store/storehooks";
import { errorNotify } from "../../services/toast.notification";
import { useNavigate } from 'react-router-dom';
import { AddPay } from "../../redux/reducers/requestPaymentSlice";
import RequestPayTable from "../../components/_common/Table/requestPayTable";
import { saveAs } from 'file-saver';


const RequestPaymentParcik = () => {
    const [data, setData] = useState<any[]>([]);
    const columns: ColumnsType<any> = [
        {
            title: '', dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Space>
                    <Button type="primary" style={{ backgroundColor: "orange" }} disabled={!permission}
                        onClick={() => downloadBase64Data(record.str_SignatureBase64, record.str_LabPersianName)} > دانلود امضا </Button>
                    <Button type="primary" style={{ backgroundColor: "green" }}
                        disabled={!permission}
                        onClick={() =>
                            downloadAttachments(record.prk_PaymentgetwayRequest_AutoID, record.str_LabPersianName)}> دانلود فایل ها  </Button>

                    {/* <a style={{ backgroundColor: "orange", padding: '5px' }} href={record.str_SignatureBase64} data-href={record.str_SignatureBase64} download> دانلود امضا </a> */}
                </Space>

            )
        },
        { title: 'نام آزمایشگاه', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName' },
        { title: 'استان', dataIndex: 'str_StateName', key: 'str_StateName' },
        { title: 'تاریخ درخواست', dataIndex: 'str_RequestDateTime', key: 'str_RequestDateTime' },
        { title: 'تاریخ انجام', dataIndex: 'str_ApproveDateTime', key: 'str_ApproveDateTime' },
        { title: 'وضعیت', dataIndex: 'str_Status', key: 'str_Status' },
        { title: 'تست درگاه', dataIndex: 'bit_IsTestPaymentgateway', key: 'bit_IsTestPaymentgateway' },
        { title: 'استفاده از ssl پارسی پل', dataIndex: 'bit_useParsipolSSL', key: 'bit_useParsipolSSL' },
        { title: 'انجام دهنده', dataIndex: 'str_ApproveuserId', key: 'str_ApproveuserId' },
        { title: 'توضیحات', dataIndex: 'str_Descritption', key: 'str_Descritption' },

    ];
    const navigate = useNavigate();
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [permission, setPermission] = useState(false);

    useEffect(() => {
        getData()

        if (myStore.auth.loginType === 'parsicuser') {
            myStore.auth.permission.map((item: any) => {
                if (item.pageName == 'RequestPayment')
                    setPermission(item.isDetailAccess);
            });
        }
        else {
            setPermission(true);
        }

    }, [])
    const getData = () => {

        getPaymentgetwayRequest(0)
            .then((result: any) => {

                result.data.data = result.data.data.map((item: any) => {
                    item.bit_useParsipolSSL = item.bit_useParsipolSSL ? 'شده' : 'نشده'
                    item.bit_IsTestPaymentgateway = item.bit_IsTestPaymentgateway ? 'شده' : 'نشده'
                    return item
                })
                setData(result.data.data);
                setIsLoading(false);

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)

            })
    }
    const uploadFile = (item: any) => {

        // navigate("/parsicuser/newMachine/" + record.prk_MachineInfo_AutoID),
        navigate("/parsicuser/PaymentUpload/" + item.prk_PaymentgetwayRequest_AutoID)
    }
    const updatePay = (data: any) => {

        dispatch(AddPay({ requestPaymen: data }))
        navigate("/parsicuser/newRequestPayment");
    }

    const downloadBase64Data = (base64String: any, fileName: any) => {
        if (base64String == null || base64String == undefined || base64String == "")
            errorNotify("امضایی ثبت نشده است.");
        else {
            let file = convertBase64ToFile(base64String, fileName);
            saveAs(file, fileName);
        }

    }

    const downloadAttachments = (requestId: any, labName: string) => {
        downloadPaymentGetwayAttachments(requestId)
            .then((result: any) => {
                if (result.data.data.length > 0) {
                    result.data.data.map((item: any) => {
                        let file = convertBase64ToFile(item.str_filesBase64, item.str_FileName);
                        saveAs(file, labName + "_" + item.str_FileName);
                    })
                }
                else
                    errorNotify("فایلی ثبت نشده است.");

                //     if (base64String == null)
                //     errorNotify("امضایی ثبت نشده است.");
                // else {
                //     let file = convertBase64ToFile(base64String, fileName);
                //     saveAs(file, fileName);
                //}
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)

            })
    }

    return (
        <>
            <Row>
                <RequestPayTable columns={columns} data={data}
                    isloading={isLoading} permission={permission} />
            </Row>
        </>
    );
};

export default RequestPaymentParcik